import { connect } from 'react-redux';
import UploadDocumentsSuccess from '../../../components/UploadDocuments/UploadDocumentsSuccess';

import {
  displayModal
} from '@xanadu/ui-shared/modules/modal/actions';

import {
  depositRequest
} from '@xanadu/ui-shared/modules/user/actions';

const mapDispatchToProps = {
  displayModal,
  depositRequest
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadDocumentsSuccess);
